/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Modal, Table } from "semantic-ui-react";
import { FormControlLabel, Radio, RadioGroup, TextField } from "@mui/material";
import { selectCurrentUserApiToken } from "../../slices/currentUser/currentUserSlice";
import { selectViewingOlderVersion } from "../../slices/viewingOlderVersion/viewingOlderVersionSlice";
import { selectAllOutcomeVariables } from "../../slices/outcomeVariables/outcomeVariablesSlice";
import { fetchUserImportanceRatings, selectAllUserImportanceRatings, selectUserImportanceRatingsStatus, userImportanceRatingAdded, userImportanceRatingUpdated } from "../../slices/userImportanceRatings/userImpotanceRatingsSlice";
import { addUserImportanceRatingToDatabase, updateUserImportanceRatingInDatabase } from "../../functions/getUserImportanceRatingDictionaryAPI";
import { globalLoadingOff, globalLoadingOn } from "../../slices/globalLoading/globalLoadingSlice";
import { handleWheel, handleKeyDown } from "../../functions/eventHandlers";

const handleChange = (name, targetfoi, value, dispatch, ratingDictionary, setChangeAvailableToSaveState) => {
    if (ratingDictionary[targetfoi]) {
        let newRating = JSON.parse(JSON.stringify(ratingDictionary[targetfoi]));
        newRating[name] = value;
        newRating.itemChanged = true;
        dispatch(userImportanceRatingUpdated(newRating));
        setChangeAvailableToSaveState(true);
    } else {
        let newRating = {
            id: targetfoi,
            exists: false,
            desirability: null,
            percentageValue: NaN,
            itemChanged: true
        }
        newRating[name] = value;
        dispatch(userImportanceRatingAdded(newRating));
        setChangeAvailableToSaveState(true);
    }
};

const DesirabilityEntry = ({ targetfoi, startingValue,
    setChangeAvailableToSaveState, ratingDictionary }) => {

    const dispatch = useDispatch();

    return <div>
        {ratingDictionary &&
            <>
                <RadioGroup row aria-label="desirability" name="desirability"
                    value={startingValue}
                    onChange={(e) => {
                        let desirability;
                        if (e.target.value === "Desirable") {
                            desirability = true;
                        }
                        if (e.target.value === "Undesirable") {
                            desirability = false;
                        }
                        handleChange("desirability", targetfoi, desirability,
                            dispatch, ratingDictionary, setChangeAvailableToSaveState);
                    }}>
                    <FormControlLabel
                        value="Desirable"
                        control={<Radio color="primary" />}
                        name="radio-button-control"
                        color="default"
                        inputprops={{ 'aria-label': 'Desirable' }}
                        labelPlacement="top"
                        label={<p style={{ textAlign: 'center' }}>Desirable</p>}
                    />
                    <FormControlLabel
                        value="Undesirable"
                        control={<Radio color="primary" />}
                        color="default"
                        name="radio-button-control"
                        inputprops={{ 'aria-label': 'Undesirable' }}
                        labelPlacement="top"
                        label={<p style={{ textAlign: 'center' }}>Undesirable</p>}
                    />
                </RadioGroup>
            </>}
    </div>
};

const QuantityValueEntry = ({ elementName, fieldLabel, targetfoi, startingValue,
    setChangeAvailableToSaveState, ratingDictionary }) => {

    const dispatch = useDispatch();

    return <div>
        {ratingDictionary &&
            <>
                <TextField style={{ width: "100%", marginTop: "16px", maxWidth: "150px" }}
                    className="inputField" type='number' inputMode='numeric' label={fieldLabel} size="small" variant='outlined'
                    value={startingValue}
                    onWheel={handleWheel}
                    onKeyDown={handleKeyDown}
                    onChange={(e) => {
                        handleChange(elementName, targetfoi, parseFloat(e.target.value),
                            dispatch, ratingDictionary, setChangeAvailableToSaveState)
                    }} />
            </>}
    </div>
};

const RateRelativeImportanceTable = ({ setChangeAvailableToSaveState }) => {

    const dispatch = useDispatch();
    const ratingstatus = useSelector(selectUserImportanceRatingsStatus);
    const outcomeVariables = useSelector(state => selectAllOutcomeVariables(state));
    const userRatings = useSelector(state => selectAllUserImportanceRatings(state));
    const ratingDictionary = {};
    for (let key in userRatings) {
        ratingDictionary[userRatings[key].id] = userRatings[key];
    }

    useEffect(() => {
        if (outcomeVariables && Object.keys(outcomeVariables).length > 0 && ratingstatus !== "succeeded") {
            dispatch(fetchUserImportanceRatings());
        }
    }, [outcomeVariables]);

    return <>
        {(ratingDictionary && outcomeVariables && Object.keys(outcomeVariables).length > 0) ?
            <Table className='viewmyworktable'>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>
                            <span>Outcome</span>
                        </Table.HeaderCell>
                        <Table.HeaderCell>
                            <span>Desirability</span>
                        </Table.HeaderCell>
                        <Table.HeaderCell>
                            <span>Relative Importance (as %)</span>
                        </Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {(outcomeVariables && Object.keys(outcomeVariables).length > 0) &&
                        Object.keys(outcomeVariables).map((targetFoi) => {
                            let item = outcomeVariables[targetFoi];
                            return <Table.Row key={targetFoi}>
                                <Table.Cell>
                                    <span title={item.resource?.description && item.resource.description} >
                                        {item.titleTrimmed || item.title}
                                    </span>
                                </Table.Cell>
                                <Table.Cell>
                                    <DesirabilityEntry
                                        targetfoi={item.id} ratingDictionary={ratingDictionary}
                                        startingValue={ratingDictionary[item.id]?.desirability ?
                                            "Desirable" :
                                            ratingDictionary[item.id]?.desirability === false ?
                                                "Undesirable" : ""}
                                        setChangeAvailableToSaveState={setChangeAvailableToSaveState} />
                                </Table.Cell>
                                <Table.Cell>
                                    <QuantityValueEntry elementName='percentageValue'
                                        targetfoi={item.id} ratingDictionary={ratingDictionary}
                                        fieldLabel={'Relative Importance (%)'}
                                        startingValue={(ratingDictionary[item.id]?.percentageValue &&
                                            !isNaN(ratingDictionary[item.id].percentageValue)) ?
                                            ratingDictionary[item.id].percentageValue.toString() : "0"}
                                        setChangeAvailableToSaveState={setChangeAvailableToSaveState} />
                                </Table.Cell>
                            </Table.Row>
                        })}
                </Table.Body>
            </Table>
            :
            <h1>Need to reload ratingDictionary</h1>
        }</>
}

const saveChanges = async (setSaveChangesState, ratingDictionary,
    apiToken, setChangeAvailableToSaveState, setRateRelativeImportanceModalState, dispatch) => {
    dispatch(globalLoadingOn());
    for (const key in ratingDictionary) {
        const item = JSON.parse(JSON.stringify(ratingDictionary[key]));
        if (item.itemChanged) {
            if (item.exists) {
                await updateUserImportanceRatingInDatabase(item, apiToken);
            }
            if (!item.exists) {
                await addUserImportanceRatingToDatabase(item, apiToken);
            }
        }
    }
    dispatch(globalLoadingOff());
    setSaveChangesState(false);
    setChangeAvailableToSaveState(false);
    setRateRelativeImportanceModalState(prevState => { return { ...prevState, modalOpen: false }; });
}

const RateRelativeImportanceModal = ({ rateRelativeImportanceModalState,
    setRateRelativeImportanceModalState, setTriggerReloadState }) => {

    const dispatch = useDispatch();
    const apiToken = useSelector(selectCurrentUserApiToken);
    const userRatings = useSelector(state => selectAllUserImportanceRatings(state));
    const ratingDictionary = {};
    for (let key in userRatings) {
        ratingDictionary[userRatings[key].id] = userRatings[key];
    }

    const [saveChangesState, setSaveChangesState] = useState(false);
    const [changeAvailableToSaveState, setChangeAvailableToSaveState] = useState(false);

    useEffect(() => {
        if (saveChangesState === true && ratingDictionary && Object.keys(ratingDictionary).length > 0) {
            saveChanges(setSaveChangesState, ratingDictionary, apiToken,
                setChangeAvailableToSaveState, setRateRelativeImportanceModalState, dispatch);
            setTriggerReloadState(true);
        }
    }, [saveChangesState]);

    let modalContent = <div style={{
        paddingTop: "0px", paddingLeft: "20px", paddingRight: "20px",
        paddingBottom: "40px", width: "100%", height: "100%", overflow: "auto"
    }}>
        <span style={{
            position: "absolute", backgroundColor: "#FFFFFF", width: "calc(90vw - 38px)", zIndex: 100,
            paddingTop: "6px", paddingBottom: "6px"
        }} >
            <Button style={{
                color: changeAvailableToSaveState ? "#FFFFFF" : "#000000",
                width: "230px", float: "left"
            }}
                className="formButton" disabled={saveChangesState}
                content="Save Changes" positive={changeAvailableToSaveState}
                onClick={() => {
                    setSaveChangesState(true);
                }}
            />
            &nbsp;&nbsp;&nbsp;
            <Button style={{ color: "#000000", width: "180px", float: "right" }}
                className="formButton"
                content="Close Window"
                onClick={() => {
                    setRateRelativeImportanceModalState(prevState => { return { ...prevState, modalOpen: false }; });
                }}
            />
        </span>
        <br /><br /><br />
        <div className='tableFixHead'>
            <RateRelativeImportanceTable
                setChangeAvailableToSaveState={setChangeAvailableToSaveState} />
        </div>
        <br /><br />
    </div>;

    return (
        <Modal
            style={{ padding: "0px", margin: "0px" }}
            dimmer={<Modal.Dimmer style={{ backgroundColor: "#00000077" }} />}
            open={rateRelativeImportanceModalState?.modalOpen}
            centered={false}
            content={modalContent}
            className="viewmywork"
        />
    )
}

const RateRelativeImportanceForUser = ({ setTriggerReloadState }) => {
    const apiToken = useSelector(selectCurrentUserApiToken);
    const viewingOlderVersion = useSelector(state => selectViewingOlderVersion(state));

    const [rateRelativeImportanceModalState, setRateRelativeImportanceModalState] = useState({ "modalOpen": false });

    return <>
        {rateRelativeImportanceModalState.modalOpen &&
            <RateRelativeImportanceModal 
                rateRelativeImportanceModalState={rateRelativeImportanceModalState}
                setRateRelativeImportanceModalState={setRateRelativeImportanceModalState}
                setTriggerReloadState={setTriggerReloadState} />}
        <span>
            <Button className="formButton" style={{ color: "#000000", width: "220px" }}
                content="Rate Relative Importance"
                onClick={() => {
                    if (apiToken) {
                        setRateRelativeImportanceModalState({ "modalOpen": true });
                    } else {
                        alert("Please login to use this function.");
                    }
                }}
                disabled={viewingOlderVersion}
            />
            &nbsp;&nbsp;&nbsp;
            <>
                Select Desirable or Undesirable and rate your relative importance of each outcome (from 0 for no importance to 100 to represent the reference value of importance).
            </>
        </span>
    </>
};

export default RateRelativeImportanceForUser;